import { useEffect } from "react";

const SUFFIX = "Black Umbrella — Vetted Black-Owned Trades & Businesses";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const usePageMeta = (name, description) => {
  useEffect(() => {
    const title = `${name} · ${SUFFIX}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", window.location.href);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
  }, [name, description]);
};
